<template>
  <thead>
    <tr>
      <th class="font-weight-regular dark--border-r">
        <slot></slot>
      </th>
      <th
        v-for="(header, i) in headersToShow"
        :key="i + 'header'"
        :class="
          (header.angled ? 'rotate' : '') +
            (header.bold ? ' font-weight-bold' : ' font-weight-regular') +
            (header.disabled ? ' disabled' : ' cursor-pointer') +
            (selected(header) || parentSelected(header) ? ' selected' : '') +
            (display(header) ? '' : ' d-none') +
            (header.value == 'empty' ? ' full-width' : '') +
            (i == 0 ? ' dark--border-r' : '')
        "
        @click="header.angled ? $emit('select', header) : null"
      >
        <span
          :class="{
            'dashed-bottom': header.expand && !selected(header),
            'font-weight-bold': selected(header)
          }"
        >
          <span>
            {{ header.text }}
          </span>
          <v-icon small color="secondary" class="mr-2" v-if="header.expand">
            {{
              selectedColumns.indexOf(header.value)
                ? "vertical_align_bottom"
                : "vertical_align_top"
            }}
          </v-icon>
        </span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "HeatmapHead",
  props: { headers: { type: Array }, selectedColumns: { type: Array } },
  data: () => ({}),
  computed: {
    headersToShow() {
      return this._.drop(this.headers);
    },
    selected() {
      return header => {
        return this.selectedColumns.indexOf(header.value) >= 0;
      };
    },
    parentSelected() {
      return header => {
        return this.selectedColumns.indexOf(header.parentValue) >= 0;
      };
    },
    display() {
      return header => {
        if (!header.parentValue) {
          return true;
        }
        return this.selectedColumns.indexOf(header.parentValue) >= 0;
      };
    }
  },
  methods: {}
};
</script>
